import { UploadFile } from '../types';

/**
 * Creates a new UploadFile record from a raw browser File object.
 * Sets status to 'idle' and progress to 0. Assigns a unique _key via crypto.randomUUID().
 */
export function createUploadFile(file: File): UploadFile {
  return {
    name: file.name,
    size: file.size,
    mimeType: file.type || undefined,
    progress: 0,
    status: 'idle',
    _key: crypto.randomUUID(),
  };
}

/**
 * Merges an adapter response (Partial<UploadFile>) into an existing UploadFile record.
 * The _key is always preserved from the original file.
 */
export function mergeUploadResponse(
  file: UploadFile,
  response: Partial<UploadFile>
): UploadFile {
  return {
    ...file,
    ...response,
    // These client-side fields must never be overwritten by the server response
    _key: file._key,
    size: response.size ?? file.size,
  };
}
